import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type State = {
  type: string
  schools: string[]
}

const initialState: State = {
  type: '',
  schools: [],
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setType: (state, action: PayloadAction<string>) => {
      state.type = action.payload
    },
    setSchools: (state, action: PayloadAction<string[]>) => {
      state.schools = action.payload
    },
    setAuthState: (state, action: PayloadAction<State>) => {
      return action.payload
    },
    resetAuthState: () => {
      return initialState
    }
  },
})

export const { setType, setSchools, setAuthState, resetAuthState } = authSlice.actions

export default authSlice.reducer